import { render } from "./fb-checkbox-checked.svg?vue&type=template&id=e9b89d74"
const script = {}
script.render = render

export default script